import React from "react";
import { Tooltip } from "antd";
import classNames from "classnames";
import { DateTime } from "luxon";
import { FC, PropsWithChildren, RefObject, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import { DocumentGridStateType, ISaveFocus } from "../../../@types/documents";
import { DocumentStatusType, GridRowHeightEnum, LoadingStatus } from "../../../@types/enumsGlobal";
import defaultStyles from "../../../Business/styles/index.module.scss";
import { DownIcon, SortIcon, UpIcon } from "../../../libs/corporate/icons/outlined/directions/ChevronCollection";
import * as ActionIcons from "../../../libs/corporate/icons/outlined/editor/ActionCollection";
import {} from "../../../Services/Extensions/Boolean";
import {} from "../../../Services/Extensions/DateTime";
import { cellValueIsKiz } from "../../../system/functions/cellValueIsKiz";
import { copyToClipboard } from "../../../system/functions/copyToClipboard";
import { exportCsv } from "../../../system/functions/exportCsv";
import { returnChequesKizStatusIcon, returnKizEditIcon, returnKizStatusIcon, returnMarkingStatusIcon, returnDisposalStatusIcon, returnStatusIcon, returnTypeIcon } from "../../../system/functions/returnStatusIcon";
import { GridFilterAction } from "../../../system/hooks/useGridFilter";
import { useAppContext } from "../../../system/providers/appContextProvider";
import { useTabsContext } from "../../../system/providers/tabsProvider";
import { useUserContext } from "../../../system/providers/userContextProvider";
import { CheckBoxMultiple } from "../../checkboxes/checkBoxMultiple";
import { ContextMenu } from "../../contextMenu/contextMenu";
import { Spinner } from "../../spiner/Spinner";
import { FormattedValueView, getFormattedCellValue } from "../components/FormattedValueView";
import { TableHeader } from "../components/TableHeader";
import { TypeScroll } from "../enum/enumScroll";
import GridPaginator from "../gridPaginator";
import styles from "./defaultGrid.module.scss";
import GridUISettings from "./gridUiSettings";
import { DocumentOperationSpinner } from "../../DocumentOperationSpinner/DocumentOperationSpinner";
import { useGridFilterValidation } from "../../../system/hooks/useGridFilterValidation";
import { reverseConversionWithType } from "../../../system/functions/conversion";

export const maxNumberPerPage: number = 10000

export interface IGridCellWithWidth extends IGridCell {
    width: number;
}

export interface IPage {
    pageNumber: number;
    prevPageNumber: number;
}

export interface actionGridRow {
    delete?: () => void;
}
function compareByOrder(a: IComparer, b: IComparer) {
    if (a.order === undefined || b.order === undefined) return 0;

    if (a.order < b.order) return -1;

    if (a.order > b.order) return 1;

    return 0;
}

interface IMousePosition {
    x: number;
    y: number;
}

export interface IColumnToSave {
    columns: IGridColumn[];
    save: boolean;
}
interface IopenWithEnterForEditProps {
    pluginTabContext?: IPlugin;
    selectedDocumentState?: DocumentStatusType | undefined;
    mnemocode?: string | undefined;
}

interface ISearchRows {
    value: string;
    gridColumn?: IGridColumn;
}

interface IGetViewCallback {
    (data: any[], totalCount?: number): void;
}

interface IDefaultGridProps {
    gridId: string;
    plugin: IPluginSettings; //настройка шапки грида
    data: any[];
    filter: IGridFilter;
    viewState?: DocumentGridStateType | GridStateType;
    dispatchGridFilter?: (value: GridFilterAction) => void;
    totalCount: number; // макс.кол записей для пагинации
    sums?: ISumsInfoViewDTO; // суммы для журнала
    actionGridRow?: actionGridRow;
    multipleSelect?: boolean; // возможность выбирать несколько строк
    selectedItem?: IGridRow; // выделенный элемент
    selectedItems?: IGridRow[]; // выделенные элементы
    selectedFirstPosition?: boolean; // выделение первой позиции
    documentStatus?: boolean; //добавление столбца с отображение статуса документа
    typeDictionaries?: boolean; //добавление столбца с отображение статуса справочника
    kizStatus?: boolean; // добавление столбца с отображением статуса киз
    markingStatus?: boolean; // добавление столбца для шапки документа общего статуса маркировки во всех партиях
    disposalStatus?: boolean; // добавления столбца для шапки документа общего статуса выбытия марок всех партий
    сhequesKizStatus?: boolean; // добавление столбца Статус кизов чеков смены
    boxStatus?: boolean; // добавление столбца с отображением статуса короба
    showQuantity?: boolean; // показывать общее количество строк в таблице
    openKizEdit?: {
        open: boolean;
        action: (row: IGridRow) => void;
    }; // Добавление столбца для редактирования киз
    numbering?: boolean; // добавление столбца с нумераций
    isEditKizs?: boolean;
    hiddenPagination?: { hiddenCountRow: boolean | undefined; hiddenNumberPage: boolean | undefined; selectAllItems?: boolean };
    autoSelect?: boolean; // автоматическое выделение первой строки
    separator?: boolean; // расширяемый разделитель
    contextMenuItems?: IContextMenuItem[];
    loadingStatus?: LoadingStatus;
    setLoadingStatus?: (value: LoadingStatus) => void; // TODO: насколько уместен?
    dataProvider?: any; // реквест для валидации
    getStyleRow?: (row: IGridRow) => string | null; // стиль для строки
    getStyleCell?: (processedCell: IGridCell, cells: IGridCell[]) => string | null; // стиль для столбца
    onSelect?: (row: IGridRow | undefined) => void; // экш для выделения элемента
    onMultipleSelect?: (rows: IGridRow[], currentRow?: IGridRow) => void; // экш для выделения элементов
    onRowClick?: (row: IGridRow) => void; // экш для клика по строке без выделения
    selectOnlyByCheckbox?: boolean; // при multipleSelect выделять только по чекбоксу, клик по строке вызывает onRowClick
    singleDirectory?: boolean; // для отображения грида на всю высоту если это грид без detailsGrids
    onDoubleClick?: (row: IGridRow) => void;
    onEnter?: (row: IGridRow) => void;
    goods?: boolean;
    onSort: (column: IGridColumn) => void;
    searching?: boolean;
    isServerFilter?: boolean;
    onFilterDelete: (column: IGridColumn) => void;
    onPageNumberChange: (pageNumber: number) => void;
    onNumberPerPageChange: (numberPerPage: number) => void;
    onGridRowContextMenuMouseClick?: (selectedRow: IGridRow, position: IMousePosition) => JSX.Element;
    getView?: (gridFilter: IGridFilter, callback: IGetViewCallback) => void;
    openWithEnterForEdit?: IopenWithEnterForEditProps;
    useUiService?: boolean;
    setPluginSettings?: (plugin: IPluginSettings) => void;
    quantityPosition?: boolean;
    localData?: boolean;
    className?: string;
    activateGroupProcessingHotKey?: boolean;
    onToggleMultipleSelect?: VoidFunction;
    clsGridWrapper?: string;
    saveFocus?: [ISaveFocus, (value: ISaveFocus) => void];
    isSearchForMultyselect?: boolean; // поиск по гриду при мультивыделении
    renderCustomCell?: (cell: IGridCell, row: IGridRow) => React.ReactNode;
}

export const DefaultGrid = <TViewDTO,>(props: PropsWithChildren<IDefaultGridProps>) => {
    const appCtx = useAppContext();
    const userCtx = useUserContext();
    const tabCtx = useTabsContext();
    let gridRef = useRef<HTMLTableSectionElement>(null);

    const [useUiService] = useState<boolean>(props.useUiService ?? true);
    const [gridRowContextMenuVisible, setGridRowContextMenuVisible] = useState(false);
    const [gridHeaderContextMenuVisible, setGridHeaderContextMenuVisible] = useState(false);
    const [showGridHeaderSettings, setShowGridHeaderSettings] = useState(false);
    const [gridRowContextMenu, setGridRowContextMenu] = useState<JSX.Element | undefined>();
    const [headerCtxPosY, setHeaderCtxPosY] = useState(0);
    const [headerCtxPosX, setHeaderCtxPosX] = useState(0);
    const [allChecked, setAllChecked] = useState<boolean>(false);
    const [typeChecked, setTypeChecked] = useState<string>("emptyField");

    const [, setPluginSettingsLoaded] = useState<boolean>(false);

    const defaultPlugin: IPluginSettings = JSON.parse(JSON.stringify(props.plugin)) as IPluginSettings;
    const [pluginSettings, setPluginSettings] = useState<IPluginSettings>(defaultPlugin);

    const [gridColumnsToSave, setGridColumnsToSave] = useState<IColumnToSave>({ columns: [], save: false });
    const [data, setData] = useState<any[]>(props?.data?.map((x) => ({ ...x, idRow: uuidv4() })));
    const [actualTotalCount, setActualTotalCount] = useState<number>(props.totalCount);
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [loadingRow, setLoadingRow] = useState<LoadingStatus>(LoadingStatus.InProcess);
    const { t } = useTranslation();
    let tableRef = useRef<HTMLDivElement>(null);
    const savedScrollLeft = useRef<number | null>(null);
    const paginationScrollLeft = useRef<number | null>(null);
    const rowRefs = useRef<Map<string, React.RefObject<HTMLTableRowElement>>>(new Map());
    //separator
    const [clientHeight, setClientHeight] = useState<number | null>(getClientHeight(data.length));
    const yDividerPos = useRef<number>(0);
    const isSeparatorResized = useRef<boolean>(false);
    const [sendRequest, setSendRequest] = useState<boolean>(false);

    const [searchRows, setSearchRows] = useState<ISearchRows>({ value: "" });
    const [searchRowsArray, setSearchRowsArray] = useState<ISearchRows[]>([]);
    const { hasFilter } = useGridFilterValidation(props.filter);

    const getOperator = (columnType: ColumnType): OperatorType => {
        if (columnType === "string") return "Like";
        if (columnType === "boolean") return "Eq";
        return "MoreOrEq";
    };

    const getValue = (columnType: ColumnType, value: string): string => {
        if (columnType === "string") return `%${value}%`;
        return value;
    };

    useEffect(() => {
        if (!searchRows.gridColumn) return;

        let newArr: ISearchRows[] = [];
        for (let i = 0; i < searchRowsArray.length; i++) {
            if (searchRowsArray[i]?.gridColumn?.order !== searchRows?.gridColumn?.order && searchRowsArray[i].value !== "") {
                newArr.push(searchRowsArray[i]);
            }
        }

        newArr.push({ value: searchRows.value, gridColumn: searchRows.gridColumn });

        if (searchRows.value === "") {
            newArr = newArr.filter((c) => c.gridColumn?.order !== searchRows.gridColumn?.order);
        }

        setSearchRowsArray([...newArr]);
    }, [searchRows]);

    const isInitialMount = useRef(true);
    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }

        if (!props.isServerFilter) return;
        const columnFilters = searchRowsArray.map((x) => {
            return {
                name: x.gridColumn?.propertyName,
                operator: getOperator(x.gridColumn?.propertyType as ColumnType),
                value: getValue(x.gridColumn?.propertyType as ColumnType, x.value),
            } as IGridColumnFilter;
        });

        props?.getView?.(
            {
                columnFilters: [...props.filter.columnFilters, ...columnFilters],
                numberPerPage: props.filter.numberPerPage,
                pageNumber: 1,
                fieldOrderBy: props.filter.fieldOrderBy,
                orderDesc: props.filter.orderDesc,
                paramFilter: props.filter.paramFilter,
            },
            (data, newTotalCount) => {
                setData([...data.map((x) => ({ ...x, idRow: uuidv4() }))]);
                if (newTotalCount !== undefined) {
                    setActualTotalCount(newTotalCount);
                }
                // Сбрасываем номер страницы
                setPageNumber({
                    pageNumber: 1,
                    prevPageNumber: 1,
                });
                
                // Сбрасываем скролл в самое начало
                if (tableRef.current) {
                    tableRef.current.scrollTo({ top: 0, behavior: 'auto' });
                }
            }
        );
    }, [searchRowsArray]);

    function getClientHeight(dataLength: number, rowHeight: number = pluginSettings?.rowHeight ?? GridRowHeightEnum.normal) {
        if (dataLength >= 10 && props.singleDirectory) {
            const height = props.filter.numberPerPage * rowHeight;
            if (tableRef.current) {
                tableRef.current.style.height = height + "px";
            }
            return height;
        } else if (dataLength >= 10 && !props.singleDirectory) {
            const height = (props.filter.numberPerPage - 1) * rowHeight;
            if (tableRef.current) {
                tableRef.current.style.height = height + "px";
            }
            return height;
        } else if (dataLength === 1) {
            if (tableRef.current) {
                tableRef.current.style.height = 100 + "px";
            }
            return  100;
        } else if (dataLength === 0) {
            if (tableRef.current) {
                tableRef.current.style.height = 65 + "px";
            }
            return 65;
        } else {
            if (tableRef.current) {
                tableRef.current.style.height = dataLength * 47 + 50 + "px";
            }
            return dataLength * 47 + 50;
        }
    }

    const onMouseHoldDown = (e) => {
        yDividerPos.current = e.clientY;
    };
    const onMouseHoldUp = () => {
        yDividerPos.current = 0;
    };

    const onMouseHoldMove = (e) => {
        if (!yDividerPos.current) {
            return;
        }
        isSeparatorResized.current = true;
        setClientHeight(clientHeight + e.clientY - yDividerPos.current);
        yDividerPos.current = e.clientY;
    };

    const getView = (gridFilter: IGridFilter, typeScroll: TypeScroll) => {
        // Объединяем фильтры из пропсов и локальные
        const columnFilters = searchRowsArray.map((x) => ({
            name: x.gridColumn?.propertyName,
            operator: getOperator(x.gridColumn?.propertyType as ColumnType),
            value: getValue(x.gridColumn?.propertyType as ColumnType, x.value),
        }));
    
        const combinedFilter = {
            ...gridFilter,
            columnFilters: [...gridFilter.columnFilters, ...columnFilters]
        } as IGridFilter;
    
        if (props.getView) {
            props.getView?.(combinedFilter, (newRows: any[], newTotalCount?: number) => {
                
                if (newRows) {
                    if (typeScroll === TypeScroll.up) {
                        scrollUp(newRows, newTotalCount);
                    } else {
                        scrollDown(newRows, newTotalCount);
                    }
                }
            });
        } else if (props.dataProvider) {
            props.dataProvider.getView(combinedFilter, (newRows: TViewDTO[], newTotalCount?: number) => {
                if (typeScroll === TypeScroll.up) {
                    scrollUp(newRows, newTotalCount);
                } else {
                    scrollDown(newRows, newTotalCount);
                }
            });
        }
    };

    const scrollUp = (newRows: TViewDTO[], newTotalCount?: number) => {
        setSendRequest(false);

        if (newTotalCount !== undefined) {
            setActualTotalCount(newTotalCount);
        }

        const currentScrollTop = tableRef.current?.scrollTop || 0;
        tableRef.current?.scrollTo({ top: Math.max(currentScrollTop * 0.7, tableRef.current?.scrollHeight / 3), left: tableRef.current?.scrollLeft });
        
        if (data.length >= props.filter.numberPerPage * 2) {
            setData([...newRows.map((x) => ({ ...x, idRow: uuidv4() })), ...data.slice(0, props.filter.numberPerPage)]);
        } else {
            setData([...newRows.map((x) => ({ ...x, idRow: uuidv4() })), ...data.slice(0, props.filter.numberPerPage)]);
        }
    };


    const scrollDown = (newRows: TViewDTO[], newTotalCount?: number) => {
        setSendRequest(false);

        if (newTotalCount !== undefined) {
            setActualTotalCount(newTotalCount);
        }

        const totalPages = Math.ceil(actualTotalCount / props.filter.numberPerPage);
        const isLastPage = pageNumber.pageNumber >= totalPages;

        if (pageNumber.pageNumber <= totalPages) {
            if (data.length >= props.filter.numberPerPage * 2) {
                if (!isLastPage && newRows && newRows.length > 0 && newRows.length >= props.filter.numberPerPage) {
                    tableRef.current?.scrollTo({ top: tableRef.current?.scrollTop / 2, left: tableRef.current?.scrollLeft });
                }
                setData([...data.slice(props.filter.numberPerPage), ...newRows.map((x) => ({ ...x, idRow: uuidv4() }))]);
            } else {
                setData([...data, ...newRows.map((x) => ({ ...x, idRow: uuidv4() }))]);
            }
        }
    };

    useEffect(() => {
        document.addEventListener("mouseup", onMouseHoldUp);
        document.addEventListener("mousemove", onMouseHoldMove);
        return () => {
            document.removeEventListener("mouseup", onMouseHoldUp);
            document.removeEventListener("mousemove", onMouseHoldMove);
        };
    });

    useEffect(() => {
        if (props.separator) {
            if (!clientHeight) {
                setClientHeight(getClientHeight(data.length));
                return;
            }
            if (tableRef.current) {
                tableRef.current.style.minHeight = clientHeight + "px";
                tableRef.current.style.maxHeight = clientHeight + "px";
            }
        }
    }, [clientHeight, tableRef.current]);

    useEffect(() => {
        if (props.separator && !isSeparatorResized.current) {
            setClientHeight(getClientHeight(data.length));
        }
    }, [data.length, props.filter.numberPerPage, props.separator]);

    // separator
    const [pageNumber, setPageNumber] = useState<IPage>({
        pageNumber: props.filter.pageNumber,
        prevPageNumber: props.filter.pageNumber,
    });
    let dataPaginator = getRows();
    useEffect(() => {
        setData(props?.data?.map((x) => ({ ...x, idRow: uuidv4() })));
    }, [props.data]);

    useEffect(() => {
        setActualTotalCount(props.totalCount);
    }, [props.totalCount]);

    useEffect(() => {
        setPageNumber({
            pageNumber: 1,
            prevPageNumber: 1,
        });
    }, [props.filter.fieldOrderBy, props.filter.orderDesc]);

    useEffect(() => {
        setPageNumber({
            pageNumber: props.filter.pageNumber,
            prevPageNumber: props.filter.pageNumber,
        });
    }, [props.filter.pageNumber]);

    useEffect(() => {
        pluginSettingsLoad();
    }, []);

    useEffect(() => {
        if (!true && !props?.multipleSelect) {
            setSelectedItem(getRows()[0]);
            props.onSelect?.(getRows()[0]);
        }
    }, [data, props.filter.pageNumber]);

    const pluginSettingsLoad = () => {
        if (useUiService) {
            setLoadingRow(LoadingStatus.InProcess);
            appCtx.uiApiService.uiPluginSettingsRequest.load(pluginSettings.mnemocode, userCtx.idGlobal, (e) => {
                if (e.respType === "isCompleted") {
                    let columns: IGridColumn[] = [];
                    e.data.gridColumns.forEach((item) => columns.push(item));
                    const plugin: IPluginSettings = {
                        name: e.data.name,
                        mnemocode: e.data.mnemocode,
                        columns: [...columns],
                        permission: pluginSettings.permission,
                        rowHeight: e.data.rowHeight,
                    };
                    setPluginSettings({ ...plugin });
                    props?.setPluginSettings?.({ ...plugin });
                    setPluginSettingsLoaded(true);
                    setClientHeight(getClientHeight(data.length, e.data.rowHeight));
                    setLoadingRow(LoadingStatus.Completed);
                } else {
                    appCtx.uiApiService.uiPluginSettingsRequest.save(
                        {
                            idUser: userCtx.idGlobal,
                            name: pluginSettings.name,
                            mnemocode: pluginSettings.mnemocode,
                            gridColumns: pluginSettings.columns,
                            detailsPlugins: [] as string[],
                            rowHeight: pluginSettings.rowHeight ?? GridRowHeightEnum.normal,
                        },
                        () => {
                            setClientHeight(getClientHeight(data.length, pluginSettings.rowHeight));
                            setPluginSettingsLoaded(true);
                            setLoadingRow(LoadingStatus.Completed);
                        }
                    );
                }
            });
        } else {
            setLoadingRow(LoadingStatus.InProcess);
            setClientHeight(getClientHeight(data.length));
            setLoadingRow(LoadingStatus.Completed);
        }
    };

    useEffect(() => setAllChecked(props.selectedItems && props.selectedItems.length > 0 ? true : false), [props.selectedItems]);

    function onClickAll(check) {
        if (check) {
            let multipleArr: IGridRow[] = [];
            getRows().map((i) => {
                multipleArr.push(i);
                props.onMultipleSelect?.([...multipleArr]);
                return i;
            });
            setAllChecked(check);
        } else {
            let multipleArr: IGridRow[] = [];
            getRows().map((i) => {
                multipleArr.push(i);
                props.onMultipleSelect?.([]);
                return i;
            });
            setAllChecked(check);
        }
    }

    const hiddenPagination = props.hiddenPagination?.hiddenNumberPage === true && props.hiddenPagination.selectAllItems;
    useEffect(() => {
        if (hiddenPagination) {
            let multipleArr: IGridRow[] = [];
            getRows().map((i) => {
                multipleArr.push(i);
                props.onMultipleSelect?.([...multipleArr]);
                return i;
            });
            setAllChecked(true);
        }
        if (props.hiddenPagination?.selectAllItems === false) {
            props.onMultipleSelect?.([]);
            setAllChecked(false);
        }
    }, [pageNumber.pageNumber, props.hiddenPagination?.selectAllItems]);

    useEffect(() => {
        if (props.autoSelect && data.length > 0) {
            const firstItem = getRows()[0];
            props.onSelect?.(firstItem);
            setSelectedItem(firstItem);
        }
        if (props.selectedFirstPosition) {
            setSelectedItem(getRows()[0]);
            props.onSelect?.(getRows()[0]);
        }
    }, [data]);

    useEffect(() => {
        const selectedRows = getRows().filter((x) => x.isSelected);
        const rowsLength = getRows().length;

        if (selectedRows.length === rowsLength) setTypeChecked("allChecked");
        else if (selectedRows.length === 0) setTypeChecked("emptyField");
        else if (selectedRows.length < rowsLength) setTypeChecked("indeterminate");
    }, [getRows()]);

    function addMissingFieldsToViewTable(currentData: any[]): any[] {
        return currentData.map((item) => {
            let newItem = Object.assign({}, item);
            pluginSettings.columns.forEach((setting) => {
                if (setting.visibility && !newItem.hasOwnProperty(setting.propertyName)) {
                    newItem[setting.propertyName] = null;
                }
            });
            return newItem;
        });
    }
    function getRows() {
        let rows: IGridRow[] = [];

        if (props.data) {
            addMissingFieldsToViewTable(data).forEach((i, index) => {
                let cells: IGridCell[] = [];
                Object.entries(i).forEach((prop) => {
                    try {
                        const propertyName = prop[0];
                        let value = prop[1];
                        const column = pluginSettings.columns.find((item) => item.propertyName === propertyName);

                        // translation - отображение значения указанного поля объекта
                        // conversion - конвертация значения из реестра конвертеров (см. conversion.ts)
                        let translation = column?.translation ?? props.plugin.columns.find((x) => x.propertyName === propertyName)?.translation;
                        let conversion = column?.conversion ?? props.plugin.columns.find((x) => x.propertyName === propertyName)?.conversion;

                        // Value translation
                        if (translation) {
                            value = Object.entries(i).find((x) => x[0] === translation)?.[1];
                        }

                        // Value conversion
                        if (conversion) {
                            value = reverseConversionWithType(conversion, value, true); // Подразумевается обратный перевод
                        }

                        let nullable = column?.nullable ?? props.plugin.columns.find((x) => x.propertyName === propertyName)?.nullable;

                        if (value && value !== null && value !== "" && column) {
                            switch (column.propertyType) {
                                case "boolean":
                                    value = (value as boolean).toYesNoString();
                                    break;
                                case "date":
                                    if (typeof value !== "string") {
                                        if (column.propertyName === "documentDate") value = (value as DateTime).toFormat("dd.MM.yyyy");
                                        else value = (value as DateTime).toF3DateFormat(userCtx);
                                        break;
                                    } else {
                                        value = null;
                                        break;
                                    }
                                case "datetime":
                                    if (typeof value !== "string") {
                                        value = (value as DateTime).toF3DateTimeFormat(userCtx);
                                        break;
                                    } else {
                                        value = null;
                                        break;
                                    }
                            }
                        }

                        const order = column?.order as number;
                        //if (propertyName == 'documentState') {
                        //    cells.push({ value: returnStatusIcon(DocumentStateType[prop[1]]), propertyName: 'СД', order: index - 1, visibility: true })
                        //}
                        cells.push({
                            value,
                            propertyName,
                            order,
                            propertyType: column?.propertyType as string,
                            visibility: pluginSettings.columns.find((x) => x.propertyName === propertyName)?.visibility as boolean,
                            nullable: nullable,
                        });
                    } catch (ex) {
                        console.trace(prop[0] + " -> " + prop[1]);
                        console.trace(ex);
                    }
                });

                props?.multipleSelect
                    ? rows.push({
                          idGoodsGlobal: i["idGoodsGlobal"] as string,
                          idGlobal: i["idGlobal"] as string,
                          idRow: i["idRow"] as string,
                          displayName: i["displayName"] as string,
                          goodsName: i["goodsName"] as string,
                          cureFormName: i["cureFormName"] as string,
                          dosage: i["dosage"] as string,
                          nFv: i["nFv"] as string,
                          substanceNameRus: i["substanceNameRus"] as string,
                          tradeNameRus: i["tradeNameRus"] as string,
                          substanceNameLat: i["substanceNameLat"] as string,
                          tradeNameLat: i["tradeNameLat"] as string,
                          quantity: i["quantity"] as number,
                          cells: cells.filter((item) => item.order !== undefined && item.order !== null).sort(compareByOrder),
                          isDeleted: i["deleted"] as boolean,
                          isLocked: i["isLocked"] as boolean,
                          isSelected: props?.selectedItems?.find((x) => x.idGlobal === i["idGlobal"]) === undefined ? false : true,
                          matchingStatus: i["matchingStatus"] as any,
                      })
                    : rows.push({
                          idGoodsGlobal: i["idGoodsGlobal"] as string,
                          idGlobal: i["idGlobal"] as string,
                          idRow: i["idRow"] as string,
                          displayName: i["displayName"] || (i["name"] as string),
                          goodsName: i["goodsName"] as string,
                          cureFormName: i["cureFormName"] as string,
                          dosage: i["dosage"] as string,
                          nFv: i["nFv"] as string,
                          substanceNameRus: i["substanceNameRus"] as string,
                          tradeNameRus: i["tradeNameRus"] as string,
                          substanceNameLat: i["substanceNameLat"] as string,
                          tradeNameLat: i["tradeNameLat"] as string,
                          quantity: i["quantity"] as number,
                          cells: cells.filter((item) => item.order !== undefined && item.order !== null).sort(compareByOrder),
                          isDeleted: i["deleted"] as boolean,
                          isLocked: i["isLocked"] as boolean,
                          isSelected: i["idRow"] === selectedItem?.idRow ? true : false,
                          isKiz: i["isKiz"] ? true : false,
                          matchingStatus: i["matchingStatus"] as any,
                      });
            });
        }
        return rows;
    }

    function getContextId(type: "header" | "row", baseId: string) {
        return `ctxMenu_${type}_${baseId}`;
    }

    useEffect(() => {
        const handler = () => setGridHeaderContextMenuVisible(false);

        if (gridHeaderContextMenuVisible === true) {
            let ctxMenu = document.getElementById(getContextId("header", props.gridId)) as HTMLElement;
            if (ctxMenu) {
                ctxMenu.onmouseleave = handler;
                return ctxMenu.removeEventListener("mouseleave", handler);
            }
        }
    }, [gridHeaderContextMenuVisible]);

    useEffect(() => {
        const handler = () => setGridRowContextMenuVisible(false);
        if (gridRowContextMenuVisible === true) {
            let ctxMenu = document.getElementById(getContextId("row", props.gridId)) as HTMLElement;
            if (ctxMenu) {
                ctxMenu.onmouseleave = handler;
                return ctxMenu.removeEventListener("mouseleave", handler);
            }
        }
    }, [gridRowContextMenuVisible]);

    useEffect(() => {
        if (gridRowContextMenu) {
            let ctxMenu = document.getElementById(getContextId("row", props.gridId)) as HTMLElement;

            if (ctxMenu) {
                ctxMenu.onmouseleave = () => setGridRowContextMenu(undefined);
                return ctxMenu.removeEventListener("mouseleave", () => setGridRowContextMenu(undefined));
            }
        }
    }, [gridRowContextMenu]);

    useEffect(() => {
        if (useUiService && gridColumnsToSave.save) {
            appCtx.uiApiService.uiPluginSettingsRequest.save(
                {
                    idUser: userCtx.idGlobal,
                    name: pluginSettings.name,
                    mnemocode: pluginSettings.mnemocode,
                    gridColumns: gridColumnsToSave.columns,
                    detailsPlugins: [] as string[],
                    rowHeight: pluginSettings.rowHeight ?? GridRowHeightEnum.normal,
                },
                () => {
                    setPluginSettings({ ...pluginSettings, columns: gridColumnsToSave.columns });
                    props?.setPluginSettings?.({ ...pluginSettings, columns: gridColumnsToSave.columns });
                    setGridColumnsToSave({ ...gridColumnsToSave, save: false });
                    setClientHeight(getClientHeight(data.length, pluginSettings.rowHeight));
                }
            );
        }
    }, [gridColumnsToSave]);

    const scrollLockCleanup = useRef<(() => void) | null>(null);

    useLayoutEffect(() => {
        if (savedScrollLeft.current !== null && tableRef.current) {
            tableRef.current.scrollLeft = savedScrollLeft.current;
            if (!gridColumnsToSave.save) {
                scrollLockCleanup.current?.();
                scrollLockCleanup.current = null;
                savedScrollLeft.current = null;
            }
        }
    }, [pluginSettings.columns, gridColumnsToSave.save]);

    const paginationScrollLockCleanup = useRef<(() => void) | null>(null);

    useLayoutEffect(() => {
        if (paginationScrollLeft.current !== null && tableRef.current) {
            tableRef.current.scrollLeft = paginationScrollLeft.current;
            paginationScrollLockCleanup.current?.();
            paginationScrollLockCleanup.current = null;
            paginationScrollLeft.current = null;
        }
    }, [data]);

    const selectionScrollLeft = useRef<number | null>(null);

    useLayoutEffect(() => {
        if (selectionScrollLeft.current !== null && tableRef.current) {
            tableRef.current.scrollLeft = selectionScrollLeft.current;
            selectionScrollLeft.current = null;
        }

        if (!selectedItem) return;

        const selectedRowElement = rowRefs.current.get(selectedItem.idGlobal)?.current;
        if (!selectedRowElement) return;

        const activeElement = document.activeElement;
        const table = selectedRowElement.closest("table");
        const gridHasFocus = activeElement === document.body || (activeElement !== null && table?.contains(activeElement));

        if (gridHasFocus) {
            selectedRowElement.focus({ preventScroll: true });
        }
    }, [selectedItem]);

    const selectRow = (row: IGridRow | undefined) => {
        selectionScrollLeft.current = tableRef.current?.scrollLeft ?? null;
        setSelectedItem(row);
    };

    const multiSelectScrollLeft = useRef<number | null>(null);

    useLayoutEffect(() => {
        if (multiSelectScrollLeft.current !== null && tableRef.current) {
            tableRef.current.scrollLeft = multiSelectScrollLeft.current;
            multiSelectScrollLeft.current = null;
        }
    }, [props.selectedItems]);

    useEffect(() => {
        props?.multipleSelect && setSelectedItem(undefined);
    }, [props?.multipleSelect]);

    const savePluginSettingsWidth = () => {
        let grid = document.getElementById(props.gridId) as HTMLElement;
        let columnCells = grid.getElementsByClassName(styles.gridColumnCell);
        const newState: IGridColumn[] = [...pluginSettings.columns];
        let changed: boolean = false;
        for (var i = 0; i < columnCells.length; i++) {
            const pName = columnCells[i].getAttribute("data-property-name");
            const column = newState.find((x) => x.propertyName === pName) as IGridColumn;
            if (column?.width !== columnCells[i].getBoundingClientRect()?.width) {
                changed = true;
                if (column?.width) {
                    column.width = parseInt(String(columnCells[i].getBoundingClientRect()?.width));
                }
            }
        }
        if (changed && pluginSettings.columns) {
            setGridColumnsToSave({ columns: newState, save: true });
        }
    };

    // const fullScreenTable = () => {
    //     let grid = document.getElementById(props.gridId) as HTMLElement;
    //     let tableWidth = grid.clientWidth;
    //     let columnCells = grid.getElementsByClassName(styles.gridColumnCell);

    //     let columnWidth = parseInt(String(tableWidth / columnCells.length));
    //     const newState: IGridColumn[] = [...pluginSettings.columns];
    //     if (pluginSettings.columns) {
    //         for (var i = 0; i < newState.length; i++) {
    //             newState[i].width = columnWidth;
    //         }
    //         setGridColumnsToSave({ columns: newState, save: true });
    //     }
    // };

    function renderSortIcon(item: IGridColumn) {
        if (props.filter.fieldOrderBy === item.propertyName && props.filter.orderDesc) return <DownIcon className={classNames(styles.sortIcon, styles.sortIcon_Selected)} />;

        if (props.filter.fieldOrderBy === item.propertyName && !props.filter.orderDesc) return <UpIcon className={classNames(styles.sortIcon, styles.sortIcon_Selected)} />;

        return <SortIcon className={styles.sortIcon} />;
    }
    const checkUpScroll = (): boolean => {
        if (tableRef.current?.scrollHeight) {
            return pageNumber.pageNumber > 1;
        } else {
            return false;
        }
    };

    const handleEnterKeyForEdit = () => {
        if (selectedItem === undefined || selectedItem?.isDeleted || props?.openWithEnterForEdit?.selectedDocumentState === "del") {
            return;
        }
        tabCtx.openChild(
            props?.openWithEnterForEdit?.pluginTabContext as IPlugin,
            "edit",
            selectedItem?.idGlobal,
            () => {
                setSelectedItem?.(undefined);
            },
            props?.openWithEnterForEdit?.mnemocode
        );
    };

    const getStyleTd = (width: string, minWidth: string) => {
        return { width: width, minWidth: minWidth, height: pluginSettings.rowHeight };
    };

    const handleExport = () => {
        // Создаем фильтр
        const filter = { ...props.filter, numberPerPage: maxNumberPerPage, pageNumber: 1 };

        // Генерируем текущую дату и время
        const dateNow = DateTime.now().toFormat("yyyy-MM-dd") + "T" + DateTime.now().toFormat("HH:mm:ss");

        // Обработка данных через props.getView или props.dataProvider.getView
        if (props.getView) {
            props.getView?.(filter, (data: any[]) => {
                exportCsv(data, dateNow, pluginSettings);
            });
        } else if (props.dataProvider?.getView) {
            props.dataProvider.getView(filter, (data: any[]) => {
                exportCsv(data, dateNow, pluginSettings);
            });
        }
    };

    //TODO Групповая обработка с помощью горячих клавиш.
    useEffect(() => {
        if (!props.activateGroupProcessingHotKey || data.length === 0) return;

        if (gridRef.current) {
            const handleKeyDown = async (event: KeyboardEvent) => {
                if (event.ctrlKey && event.key.toLowerCase() === "a") {
                    //Добавление лоадера, и имитация запроса.
                    setSendRequest(true);
                    await new Promise((resolve) => setTimeout(resolve, 0));

                    //Переключение групп. обработки в родительском компоненте.
                    let multipleSelect = props.multipleSelect;
                    if (!multipleSelect) {
                        multipleSelect = true;
                        props.onToggleMultipleSelect?.();
                    }

                    if (multipleSelect && props.selectedItems) {
                        const arr = getRows(); //Получение текущего списка.
                        // Фуникцонал для удаления дублей и добавления только уник. значений.
                        const existingIds = new Set(props.selectedItems!.map((item) => item.idGlobal));
                        const uniqueRows = arr.filter((item) => !existingIds.has(item.idGlobal));
                        const updatedItems = [...props.selectedItems, ...uniqueRows];

                        if (uniqueRows.length > 0) {
                            props.onMultipleSelect?.(updatedItems);
                        }
                    }
                    setSendRequest(false);
                }
            };
            document.addEventListener("keydown", handleKeyDown);

            return () => {
                document.removeEventListener("keydown", handleKeyDown);
            };
        }
    }, [loadingRow, props.loadingStatus, props.multipleSelect, props.selectedItems, data, props.selectedItem]);

    // Сохранение фокуса при проведении, распроведении и удалении позиции

    useEffect(() => {
        if (props.saveFocus) {
                if (props.saveFocus[0]?.viewState === 'process') {
                    setData(prev => {
                        const updateData = prev.map(el => (el.idGlobal === selectedItem?.idGlobal) ? {...el, documentState: 'proc'} : el);
                        const foundItem = updateData.find(el => el.idGlobal === selectedItem?.idGlobal)
                        props.saveFocus?.[1]?.({viewState: 'view', selectedItem: foundItem, data: updateData});
                        return updateData;  
                    })
                }
                if (props.saveFocus[0]?.viewState === 'unprocess') {
                    setData(prev => {
                        const updateData = prev.map(el => (el.idGlobal === selectedItem?.idGlobal) ? {...el, documentState: 'draft'} : el);
                        const foundItem = updateData.find(el => el.idGlobal === selectedItem?.idGlobal)
                        props.saveFocus?.[1]?.({viewState: 'view', selectedItem: foundItem, data: updateData});
                        return updateData;  
                    })
                }
                if (props.saveFocus[0]?.viewState === 'delete') {
                    setData(prev => {
                        const updateData = prev.map(el => (el.idGlobal === selectedItem?.idGlobal) ? {...el, documentState: 'del', deleted: true} : el);
                        const foundItem = updateData.find(el => el.idGlobal === selectedItem?.idGlobal)
                        props.saveFocus?.[1]?.({viewState: 'view', selectedItem: foundItem, data: updateData});
                        return updateData;  
                    })
                }
                if (props.saveFocus[0]?.viewState === "restore") {
                    setData((prev) => {
                        const updateData = prev.map((el) => (el.idGlobal === selectedItem?.idGlobal ? { ...el, documentState: "draft", deleted: false } : el));
                        const foundItem = updateData.find((el) => el.idGlobal === selectedItem?.idGlobal);
                        props.saveFocus?.[1]?.({ viewState: "view", selectedItem: foundItem, data: updateData });
                        return updateData;
                    });
                }
        }
    }, [props.saveFocus?.[0]?.viewState]);

    // ---------------------------------------------------------------

    if (loadingRow === LoadingStatus.InProcess) return <Spinner />;

    return (
        <>
            {props.loadingStatus === LoadingStatus.InProcess ? (
                <DocumentOperationSpinner xl/>
            ) : props.loadingStatus === LoadingStatus.NoAccess ? (
                <div className={styles.noDataInfo}>
                    <span>Нет доступа</span>
                </div>
            ) : props.loadingStatus === LoadingStatus.NoData ? (
                <div className={styles.noDataInfo}>
                    <span>{t("general.noData")}</span>
                </div>
            ) : (
                <>
                    <div className={classNames(styles.gridWrapper, props.className)}>
                        {props.quantityPosition && <div className={styles.quantityPositions}>Кол-во позиций: {props.totalCount}</div>}
                        <div
                            className={classNames(props.clsGridWrapper, styles.gridWrapper__tables, sendRequest ? styles.gridWrapper__tables__disabledScroll : "")}
                            ref={tableRef}
                            onScroll={(scroll) => {
                                if (!props.localData) {
                                    if (!props.hiddenPagination?.hiddenNumberPage) {
                                        //если поисковый режим ColumnFilters или Expression и multipleSelect - не делаем запросы (для плагина Отчет по движению в отделения (NEW))
                                        const allDataLoaded = hasFilter && props.data.length > props.filter.numberPerPage && props.isSearchForMultyselect;
                                        if (allDataLoaded) {                                           
                                            return;
                                        }

                                        let lastScrollTop: number = 0;
                                        const scrollTop: number = scroll.currentTarget.scrollTop;
                                        const scrollHeight: number = scroll.currentTarget.scrollHeight;
                                        const clientHeight: number = scroll.currentTarget.clientHeight;
                                        const conditionScroll: boolean =
                                            scrollHeight - scrollTop === clientHeight ||
                                            Math.round(scrollHeight - scrollTop) === clientHeight ||
                                            Math.round(scrollHeight - scrollTop - 1) === clientHeight ||
                                            Math.round(scrollHeight - scrollTop + 1) === clientHeight;

                                        if (scrollTop > lastScrollTop) {
                                            const totalPages = Math.ceil(props.totalCount / props.filter.numberPerPage);
                                            const isNotLastPage = pageNumber.pageNumber < totalPages;
                                            
                                            if (tableRef.current?.scrollHeight && isNotLastPage && conditionScroll && !sendRequest) {
                                                const totalPages = Math.ceil(actualTotalCount / props.filter.numberPerPage);
                                                const nextPageNumber = pageNumber.pageNumber + 1;

                                                if (nextPageNumber <= totalPages) {
                                                    
                                                    setPageNumber({
                                                        pageNumber: nextPageNumber,
                                                        prevPageNumber: pageNumber.pageNumber,
                                                    });
                                                    
                                                    if (
                                                        (props.plugin.mnemocode === 'goods_group_plugin' && props.isSearchForMultyselect) ||
                                                        (props.plugin.mnemocode === 'sys_option_goods_group_plugin' && props.isSearchForMultyselect) ||
                                                        props.plugin.mnemocode === 'report_filter_mnemocode'
                                                    ) {
                                                        setSendRequest(false);
                                                    } else {
                                                        const el = tableRef.current;
                                                        if (el) {
                                                            const lockedLeft = el.scrollLeft;
                                                            paginationScrollLeft.current = lockedLeft;
                                                            let rafId: number | null = null;
                                                            const lock = () => {
                                                                if (el.scrollLeft !== lockedLeft) el.scrollLeft = lockedLeft;
                                                                rafId = requestAnimationFrame(lock);
                                                            };
                                                            rafId = requestAnimationFrame(lock);
                                                            paginationScrollLockCleanup.current = () => { if (rafId !== null) cancelAnimationFrame(rafId); };
                                                        }
                                                        setSendRequest(true);
                                                        getView({ ...props.filter, pageNumber: nextPageNumber }, TypeScroll.down);
                                                    }
                                                }
                                            }
                                        } else {
                                            if (checkUpScroll()) {
                                                if (scroll.currentTarget.scrollTop < 5 || scroll.currentTarget.scrollTop === 0) {
                                                    const pageNum = pageNumber.pageNumber - 2;
                                                    if (pageNum > 0) {
                                                        setPageNumber({
                                                            pageNumber: pageNumber.pageNumber - 1,
                                                            prevPageNumber: pageNumber.pageNumber,
                                                        });
                                                        if (
                                                            (props.plugin.mnemocode === 'goods_group_plugin' && props.isSearchForMultyselect) ||
                                                            (props.plugin.mnemocode === 'sys_option_goods_group_plugin' && props.isSearchForMultyselect) ||
                                                            props.plugin.mnemocode === 'report_filter_mnemocode'
                                                        ) {
                                                            setSendRequest(false);
                                                        } else {
                                                        const el = tableRef.current;
                                                        if (el) {
                                                            const lockedLeft = el.scrollLeft;
                                                            paginationScrollLeft.current = lockedLeft;
                                                            let rafId: number | null = null;
                                                            const lock = () => {
                                                                if (el.scrollLeft !== lockedLeft) el.scrollLeft = lockedLeft;
                                                                rafId = requestAnimationFrame(lock);
                                                            };
                                                            rafId = requestAnimationFrame(lock);
                                                            paginationScrollLockCleanup.current = () => { if (rafId !== null) cancelAnimationFrame(rafId); };
                                                        }
                                                        setSendRequest(true);
                                                        getView({ ...props.filter, pageNumber: pageNum }, TypeScroll.up);
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                        lastScrollTop = scrollTop;
                                    }
                                }
                            }}
                        >
                            <table id={props.gridId} className={styles.gridTable}>
                                        {props.showQuantity && (
                                        <div className={styles.showQuantity}>
                                            Общее кол-во: <b>{actualTotalCount}</b>
                                            {props.sums?.supplierSumInfo?.sumIncVat != null && (
                                            <> &nbsp;| Сум.пост <b>{props.sums.supplierSumInfo.sumIncVat}</b>
                                            &nbsp;| Сум.розн. <b>{props.sums.retailSumInfo.sumIncVat}</b>
                                            &nbsp;| Сум.пост. б/НДС <b>{props.sums.supplierSumInfo.sum}</b>
                                            &nbsp;| Сум.роз. б/НДС <b>{props.sums.retailSumInfo.sum}</b>
                                            </>
                                            )}
                                        </div>
                                        )}
                                <thead
                                    className={props.showQuantity ? styles.gridColumnsHeader__showQuantity : styles.gridColumnsHeader}
                                    onContextMenu={(e) => {
                                        if (process.env.REACT_APP_SHOW_GRID_CONTEXT === "true") {
                                            e.preventDefault();
                                            
                                            const menuWidth = 145;
                                            const menuHeight = 70;
        
                                            const modalPortal = document.getElementById('react-portal-modal-container');        
                                            const modalOverlay = modalPortal?.querySelector('[class*="BaseModalWindow_modalOverlay"]');        
                                            const modalWindow = modalOverlay?.querySelector('[class*="BaseModalWindow_modalEditValues"]');
        
                                            if (!modalWindow) {
                                                const viewportWidth = window.innerWidth;
                                                const viewportHeight = window.innerHeight;
        
                                                const showOnLeft = e.clientX > viewportWidth - menuWidth;
                                                const showOnTop = e.clientY > viewportHeight - menuHeight;
        
                                                setHeaderCtxPosX(showOnLeft ? e.clientX - menuWidth : e.clientX);
                                                setHeaderCtxPosY(showOnTop ? e.clientY - menuHeight : e.clientY);
                                                setGridHeaderContextMenuVisible(true);
                                                return;
                                            };
        
                                            if (modalWindow) {
                                                const modalRect = modalWindow.getBoundingClientRect();
        
                                                const modalStyle = window.getComputedStyle(modalWindow);
        
                                                const paddingLeft = parseFloat(modalStyle.paddingLeft) || 0;
                                                const paddingTop = parseFloat(modalStyle.paddingTop) || 0;
                                                
                                                const availableWidth = modalRect.width - paddingLeft - (parseFloat(modalStyle.paddingRight) || 0);
                                                const availableHeight = modalRect.height - paddingTop - (parseFloat(modalStyle.paddingBottom) || 0);
                                                
                                                const xInModal = e.clientX - modalRect.left - paddingLeft;
                                                const yInModal = e.clientY - modalRect.top - paddingTop;
        
                                                const showOnLeft = xInModal > availableWidth - menuWidth;
                                                const showOnTop = yInModal > availableHeight - menuHeight;
                                                
                                                setHeaderCtxPosX(showOnLeft ? xInModal - menuWidth : xInModal);
                                                setHeaderCtxPosY(showOnTop ? yInModal - menuHeight : yInModal);
                                            } else {
                                                setHeaderCtxPosX(e.clientX);
                                                setHeaderCtxPosY(e.clientY);
                                            }
                                            setGridHeaderContextMenuVisible(true);
                                        }
                                    }}
                                    style={{ height: pluginSettings.rowHeight }}
                                >
                                    <tr className={styles.gridColumn}
                                        // onDoubleClick={(e) => fullScreenTable()}
                                        onMouseUp={(e) => savePluginSettingsWidth()}
                                    >
                                        {props.multipleSelect && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "45px", minWidth: "45px" }}>
                                                <CheckBoxMultiple checked={typeChecked} onChange={() => onClickAll(!allChecked)} />
                                            </td>
                                        )}
                                        {props.documentStatus && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "55px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}>СД</span>
                                            </td>
                                        )}
                                        {props.typeDictionaries && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "65px", minWidth: "65px" }}>
                                                <span className={styles.gridColumnHeaderName}>Тип</span>
                                            </td>
                                        )}
                                        {props.openKizEdit && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "55px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}></span>
                                            </td>
                                        )}
                                        {props.kizStatus && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "55px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}>СК</span>
                                            </td>
                                        )}
                                        {props.markingStatus && (
                                            <td title="Маркировка" draggable={false} className={styles.additionalGridColumnCell} style={{ width: "60px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}>СМ</span>
                                            </td>
                                        )}
                                        {props.disposalStatus && (
                                            <td title="Выбытие КИЗ" draggable={false} className={styles.additionalGridColumnCell} style={{ width: "60px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}>СВ</span>
                                            </td>
                                        )}
                                        {props.сhequesKizStatus && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "55px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}>СК</span>
                                            </td>
                                        )}
                                        {props.boxStatus && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "55px", minWidth: "55px" }}>
                                                <span className={styles.gridColumnHeaderName}>СК</span>
                                            </td>
                                        )}
                                        {props.numbering && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "45px", minWidth: "45px" }}>
                                                <span className={styles.gridColumnHeaderName}>№</span>
                                            </td>
                                        )}
                                        {props.isEditKizs && (
                                            <td draggable={false} className={styles.additionalGridColumnCell} style={{ width: "75px", minWidth: "75px" }}>
                                                <span className={styles.gridColumnHeaderName}>IdError</span>
                                            </td>
                                        )}

                                        <>
                                            {pluginSettings.columns.sort(compareByOrder).map((item, index) => {
                                                const defaultPropertySetting = props.plugin.columns.find((i) => i.propertyName === item.propertyName);
                                                const sorting = defaultPropertySetting?.sorting ?? true;
                                                let filtered = props.filter.columnFilters.filter((i) => i.name === item.propertyName && i.invisible === false).length > 0;
                                                return (
                                                    item.visibility && (
                                                        <TableHeader
                                                            index={index}
                                                            draggable={true}
                                                            item={item}
                                                            filtered={filtered}
                                                            pluginSettings={pluginSettings}
                                                            setGridColumnsToSave={setGridColumnsToSave}
                                                            sorting={sorting}
                                                            onSort={props.onSort}
                                                            searching={props.searching}
                                                            value={searchRowsArray.find((c) => c.gridColumn == item)?.value}
                                                            onSearch={(value, column) => {
                                                                setSearchRows({ value: value, gridColumn: column });
                                                            }}
                                                            onPageNumberChange={props.onPageNumberChange}
                                                            setPageNumber={setPageNumber}
                                                            renderSortIcon={renderSortIcon}
                                                            setLoadingStatus={props.setLoadingStatus}
                                                            onFilterDelete={props.onFilterDelete}
                                                            filter={props.filter}
                                                            onResizeStart={() => {
                                                                const el = tableRef.current;
                                                                if (!el) return;
                                                                const lockedScrollLeft = el.scrollLeft;
                                                                savedScrollLeft.current = lockedScrollLeft;
                                                                let rafId: number | null = null;
                                                                const lock = () => {
                                                                    if (el.scrollLeft !== lockedScrollLeft) {
                                                                        el.scrollLeft = lockedScrollLeft;
                                                                    }
                                                                    rafId = requestAnimationFrame(lock);
                                                                };
                                                                rafId = requestAnimationFrame(lock);
                                                                scrollLockCleanup.current = () => {
                                                                    if (rafId !== null) cancelAnimationFrame(rafId);
                                                                };
                                                            }}
                                                            onReorderEnd={() => {
                                                                const el = tableRef.current;
                                                                if (!el) return;
                                                                const lockedScrollLeft = el.scrollLeft;
                                                                savedScrollLeft.current = lockedScrollLeft;
                                                                let rafId: number | null = null;
                                                                const lock = () => {
                                                                    if (el.scrollLeft !== lockedScrollLeft) {
                                                                        el.scrollLeft = lockedScrollLeft;
                                                                    }
                                                                    rafId = requestAnimationFrame(lock);
                                                                };
                                                                rafId = requestAnimationFrame(lock);
                                                                scrollLockCleanup.current = () => {
                                                                    if (rafId !== null) cancelAnimationFrame(rafId);
                                                                };
                                                            }}
                                                            cls={{
                                                                tD: styles.gridColumnCell,
                                                                tooltip: styles.gridColumnHeaderName,
                                                                sortingDiv: styles.gridColumnCellButtons,
                                                                sortingDivButton: styles.gridSortButton,
                                                                searchDropDivButton: styles.searchDropDivButton,
                                                                filteredDiv: styles.gridFilterButton,
                                                            }}
                                                        />
                                                    )
                                                );
                                            })}
                                        </>
                                    </tr>
                                </thead>
                                <tbody className={styles.gridRowsGroup} ref={gridRef}>
                                    {getRows()
                                        .filter((element) => {
                                            let itСheck: boolean = true;
                                            if (props.isServerFilter) return itСheck;
                                            searchRowsArray.forEach((el) => {
                                                switch (element?.cells.find((x) => x.order === el.gridColumn?.order)?.propertyType) {
                                                    case "string":
                                                    case "date":
                                                    case "datetime":
                                                        if (
                                                            element?.cells.find((x) => x.order === el.gridColumn?.order)?.value !== null &&
                                                            !element?.cells
                                                                .find((x) => x.order === el.gridColumn?.order)
                                                                ?.value.toLowerCase()
                                                                .includes(el?.value.toLowerCase())
                                                        ) {
                                                            itСheck = false;
                                                        }
                                                        break;
                                                    case "number":
                                                    case "decimal":
                                                        if (!String(element?.cells.find((x) => x.order === el.gridColumn?.order)?.value).includes(el?.value)) {
                                                            itСheck = false;
                                                        }
                                                        break;
                                                    case "boolean":
                                                        let isSearchingTrue: boolean = /^[да]*$/.test(el?.value.toLowerCase());
                                                        let isSearchingFalse: boolean = /^[нет]*$/.test(el?.value.toLowerCase());
                                                        if (
                                                            isSearchingTrue &&
                                                            (element?.cells.find((x) => x.order === el.gridColumn?.order)?.value === false ||
                                                                element?.cells.find((x) => x.order === el.gridColumn?.order)?.value === null ||
                                                                element?.cells.find((x) => x.order === el.gridColumn?.order)?.value === undefined)
                                                        ) {
                                                            itСheck = false;
                                                        } else if (
                                                            isSearchingFalse &&
                                                            (element?.cells.find((x) => x.order === el.gridColumn?.order)?.value === "Да" ||
                                                                element?.cells.find((x) => x.order === el.gridColumn?.order)?.value === true)
                                                        ) {
                                                            itСheck = false;
                                                        }
                                                        break;
                                                }
                                            });
                                            return itСheck;
                                        })
                                        .map((item, index) => {
                                            const itemIdGlobal = item.idGlobal;
                                            const cells = item.cells;
                                            const displayColumns = (gridColumnsToSave.save && gridColumnsToSave.columns.length > 0)
                                                ? gridColumnsToSave.columns
                                                : pluginSettings.columns;
                                            let orderedCells: IGridCellWithWidth[] = [];
                                            for (let i = 0; i < cells.length; i++) {
                                                orderedCells.push({
                                                    ...cells[i],
                                                    order: displayColumns.find((item) => item.propertyName === cells[i].propertyName)?.order as number,
                                                    width: displayColumns.find((item) => item.propertyName === cells[i].propertyName)?.width as number,
                                                });
                                            }
                                            orderedCells = orderedCells.sort(compareByOrder);
                                            const isProc: boolean = cells?.some((el) => el.propertyName === "documentState" && el.value === "proc"); //Проверка для отображения документа статус киз.

                                            return (
                                                <tr
                                                    ref={(el) => {
                                                        if (el) {
                                                            rowRefs.current.set(itemIdGlobal, { current: el } as React.RefObject<HTMLTableRowElement>);
                                                        }
                                                    }}
                                                    onContextMenu={(e) => {
                                                        if (process.env.REACT_APP_SHOW_GRID_CONTEXT === "true") {
                                                            e.preventDefault();
                                                            setGridRowContextMenu(props.onGridRowContextMenuMouseClick?.(item, { x: e.pageX - 5, y: e.pageY - 5 }));
                                                        }

                                                        if (props.contextMenuItems && selectedItem) {
                                                            setHeaderCtxPosX(e.pageX);
                                                            setHeaderCtxPosY(e.pageY);
                                                            setGridRowContextMenuVisible(true);
                                                        }
                                                    }}
                                                    key={`key-${index}`}
                                                    tabIndex={-1}
                                                    data-item-id={item.idGlobal}
                                                    className={classNames(
                                                        styles.gridRow,
                                                        props.getStyleRow?.(item),
                                                        item.isSelected && !props.selectOnlyByCheckbox ? styles.gridRowSelected : null,
                                                        item.isDeleted ? styles.gridRowDeleted : null,
                                                        item.isLocked ? styles.gridRowLocked : null
                                                    )}
                                                    onClick={(e) => {
                                                        if (props?.selectOnlyByCheckbox && props?.multipleSelect) {
                                                            props.onRowClick?.(item);
                                                            return;
                                                        }

                                                        if (props?.multipleSelect) {
                                                            multiSelectScrollLeft.current = tableRef.current?.scrollLeft ?? null;
                                                            if (props?.selectedItems?.length === 0) {
                                                                props.onMultipleSelect?.([item], item);
                                                            }
                                                            if (props?.selectedItems) {
                                                                props?.selectedItems?.find((x) => x.idGlobal === item.idGlobal) === undefined &&
                                                                    props.onMultipleSelect?.([...props.selectedItems, item], item);
                                                            }
                                                            if (item.isSelected && props?.selectedItems) {
                                                                const newSelectedArray = props?.selectedItems?.filter((x) => x.idGlobal !== item.idGlobal);
                                                                props.onMultipleSelect?.([...newSelectedArray], item);
                                                            }
                                                        } else {
                                                            if (item.isSelected) {
                                                                let target = (e.target as Element).className as unknown as SVGAnimatedString;
                                                                const isTargetSvgMini = target.baseVal?.includes("svgMini");
                                                                if (!isTargetSvgMini) {
                                                                    selectRow(undefined);
                                                                    props.onMultipleSelect?.([]);
                                                                    props.onSelect?.(undefined);
                                                                    setGridRowContextMenuVisible(false);
                                                                }
                                                            } else {
                                                                selectRow(item);
                                                                props.onSelect?.(item);
                                                            }
                                                        }
                                                    }}
                                                    onKeyDown={(eKeyPress) => {
                                                        switch (eKeyPress.key) {
                                                            case "ArrowDown":
                                                            case "Tab":
                                                                eKeyPress.preventDefault();
                                                                const ArrowDownRef = tableRef.current;
                                                                const ArrowDownRefBody = ArrowDownRef?.querySelector("tbody");
                                                                const ArrowDownRefChildren = ArrowDownRefBody?.children;

                                                                const scrollHeightDown = ArrowDownRef?.scrollHeight as number;
                                                                const clientHeightDown = ArrowDownRef?.clientHeight as number;
                                                                const scrollTopDown = ArrowDownRef?.scrollTop as number;

                                                                let lastRowArrowDown;
                                                                for (let i = 0; i < dataPaginator.length; i++) {
                                                                    if (dataPaginator[i].idGlobal === selectedItem?.idGlobal) {
                                                                        if (i + 1 < dataPaginator.length) {
                                                                            selectRow(dataPaginator[i + 1]);
                                                                            props.onSelect?.(dataPaginator[i + 1]);

                                                                            ArrowDownRefChildren &&
                                                                                ArrowDownRefChildren[i + 2]?.scrollIntoView({
                                                                                    behavior: "smooth",
                                                                                    block: "nearest",
                                                                                    inline: "start",
                                                                                });
                                                                        } else lastRowArrowDown = i + 1;
                                                                        if (scrollTopDown + clientHeightDown > scrollHeightDown - 25 && lastRowArrowDown !== undefined) {
                                                                            ArrowDownRef?.scrollBy({
                                                                                top: 100,
                                                                                left: 0,
                                                                                behavior: "smooth",
                                                                            });
                                                                        }
                                                                        break;
                                                                    }
                                                                }

                                                                if (props.hiddenPagination?.hiddenCountRow && props.hiddenPagination?.hiddenNumberPage) {
                                                                    let lastRow;
                                                                    for (let i = 0; i < dataPaginator.length; i++) {
                                                                        if (dataPaginator[i].idGlobal === selectedItem?.idGlobal) {
                                                                            if (i + 1 < dataPaginator.length) {
                                                                                selectRow(dataPaginator[i + 1]);
                                                                                props.onSelect?.(dataPaginator[i + 1]);
                                                                            } else lastRow = i + 1;
                                                                        }
                                                                    }
                                                                    if (props.hiddenPagination?.hiddenCountRow && props.hiddenPagination?.hiddenNumberPage) {
                                                                        if (lastRow === dataPaginator.length && props.totalCount / props.filter.numberPerPage > props.filter.pageNumber) {
                                                                            props.filter.pageNumber++;
                                                                            props.onPageNumberChange(props.filter.pageNumber);
                                                                        }
                                                                    }
                                                                    let nextElement = eKeyPress.currentTarget.nextElementSibling as HTMLElement;
                                                                    if (nextElement != null) nextElement.focus();
                                                                    break;
                                                                } else {
                                                                    break;
                                                                }

                                                            case "ArrowUp":
                                                                eKeyPress.preventDefault();
                                                                const ArrowUpRef = tableRef.current;
                                                                const ArrowUpRefBody = ArrowUpRef?.querySelector("tbody");
                                                                const ArrowUpRefChildren = ArrowUpRefBody?.children;
                                                                const scrollTopUp = ArrowUpRef?.scrollTop as number;

                                                                let firstRow;
                                                                for (let i = data.length - 1; i >= 0; i--) {
                                                                    if (dataPaginator[i].idGlobal === selectedItem?.idGlobal) {
                                                                        if (i - 1 >= 0) {
                                                                            selectRow(dataPaginator[i - 1]);
                                                                            props.onSelect?.(dataPaginator[i - 1]);

                                                                            ArrowUpRefChildren &&
                                                                                ArrowUpRefChildren[i - 2]?.scrollIntoView({
                                                                                    behavior: "smooth",
                                                                                    block: "nearest",
                                                                                    inline: "start",
                                                                                });
                                                                        } else firstRow = i - 1;
                                                                        if ((scrollTopUp as number) < 45) {
                                                                            ArrowUpRef?.scrollBy({
                                                                                top: -100,
                                                                                left: 0,
                                                                                behavior: "smooth",
                                                                            });
                                                                        }
                                                                        break;
                                                                    }
                                                                }

                                                                if (props.hiddenPagination?.hiddenCountRow && props.hiddenPagination?.hiddenNumberPage) {
                                                                    let firstRow;
                                                                    for (let i = data.length - 1; i >= 0; i--) {
                                                                        if (dataPaginator[i].idGlobal === selectedItem?.idGlobal) {
                                                                            if (i - 1 >= 0) {
                                                                                selectRow(dataPaginator[i - 1]);
                                                                                props.onSelect?.(dataPaginator[i - 1]);
                                                                            } else firstRow = i - 1;
                                                                        }
                                                                    }
                                                                    if (props.hiddenPagination?.hiddenCountRow && props.hiddenPagination?.hiddenNumberPage) {
                                                                        props.filter.pageNumber--;
                                                                        props.onPageNumberChange(props.filter.pageNumber);
                                                                    }
                                                                    break;
                                                                } else {
                                                                    break;
                                                                }

                                                            case "ArrowRight":
                                                                if (props.hiddenPagination?.hiddenCountRow && props.hiddenPagination?.hiddenNumberPage) {
                                                                    if (props.totalCount / props.filter.numberPerPage > props.filter.pageNumber && props.hiddenPagination?.hiddenNumberPage) {
                                                                        props.filter.pageNumber++;
                                                                        props.onPageNumberChange(props.filter.pageNumber);
                                                                    }
                                                                    break;
                                                                } else {
                                                                    break;
                                                                }

                                                            case "ArrowLeft":
                                                                if (props.hiddenPagination?.hiddenCountRow && props.hiddenPagination?.hiddenNumberPage) {
                                                                    if (props.filter.pageNumber > 1 && props.hiddenPagination?.hiddenNumberPage) {
                                                                        props.filter.pageNumber--;
                                                                        props.onPageNumberChange(props.filter.pageNumber);
                                                                    }
                                                                    break;
                                                                } else {
                                                                    break;
                                                                }

                                                            case "Enter":
                                                                if (props.onEnter) {
                                                                    selectedItem && item && props.onEnter(item);
                                                                }
                                                                if (selectedItem && props.openWithEnterForEdit?.selectedDocumentState && props.openWithEnterForEdit.pluginTabContext) {
                                                                    handleEnterKeyForEdit();
                                                                }
                                                                break;

                                                            case "Escape":
                                                                if (selectedItem) {
                                                                    selectRow(undefined);
                                                                    props.onMultipleSelect?.([]);
                                                                    props.onSelect?.(undefined);
                                                                }
                                                                break;

                                                            case "Delete":
                                                                props.actionGridRow?.delete?.();
                                                                break;
                                                            default:
                                                                break;
                                                        }
                                                    }}
                                                    onDoubleClick={() => {
                                                        !props.multipleSelect && props.onDoubleClick?.(item);
                                                    }}
                                                >
                                                    {props.multipleSelect && (
                                                        <td
                                                            className={styles.gridRowCell}
                                                            style={getStyleTd("45px", "45px")}
                                                            onClick={props.selectOnlyByCheckbox ? (e) => {
                                                                e.stopPropagation();
                                                                const exists = props.selectedItems?.some((x) => x.idGlobal === item.idGlobal);
                                                                let newSelectedItems: IGridRow[];
                                                                if (exists) {
                                                                    newSelectedItems = props.selectedItems?.filter((x) => x.idGlobal !== item.idGlobal) ?? [];
                                                                } else {
                                                                    newSelectedItems = [...(props.selectedItems ?? []), item];
                                                                }
                                                                props.onMultipleSelect?.(newSelectedItems, item);
                                                            } : undefined}
                                                        >
                                                            <input type="checkbox" checked={item.isSelected} readOnly />
                                                        </td>
                                                    )}
                                                    {props.documentStatus && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("55px", "55px")}>
                                                            {returnStatusIcon(item.cells.find((x) => x["propertyName"] === "documentState")?.value)}
                                                        </td>
                                                    )}
                                                    {props.typeDictionaries && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("65px", "65px")}>
                                                            {returnTypeIcon(item.cells.find((x) => x["propertyName"] === "type")?.value)}
                                                        </td>
                                                    )}
                                                    {props.openKizEdit && props.openKizEdit.open && props.openKizEdit.action && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("55px", "55px")}>
                                                            {returnKizEditIcon(cellValueIsKiz(item.cells), () => {
                                                                props.openKizEdit?.action(item);
                                                            })}
                                                        </td>
                                                    )}
                                                    {props.kizStatus && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("55px", "55px")}>
                                                            {returnKizStatusIcon(item.cells.find((x) => x["propertyName"] === "kizState")?.value)}
                                                        </td>
                                                    )}
                                                    {props.markingStatus && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("60px", "55px")}>
                                                            {returnMarkingStatusIcon(item.cells.find((x) => x["propertyName"] === "markingStatus")?.value)}
                                                        </td>
                                                    )}
                                                    {props.disposalStatus && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("60px", "55px")}>
                                                            {returnDisposalStatusIcon(item.cells.find((x) => x["propertyName"] === "disposalStatus")?.value)}
                                                        </td>
                                                    )}
                                                    {props.сhequesKizStatus && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("55px", "55px")}>
                                                            {returnChequesKizStatusIcon(item.cells.find((x) => x["propertyName"] === "chequesKizStatus")?.value)}
                                                        </td>
                                                    )}
                                                    {props.boxStatus && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("55px", "55px")}>
                                                            {returnKizStatusIcon(item.cells.find((x) => x["propertyName"] === "kizState")?.value)}
                                                        </td>
                                                    )}
                                                    {props.numbering && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("45px", "45px")}>
                                                            {index + 1}
                                                        </td>
                                                    )}
                                                    {props.isEditKizs && (
                                                        <td className={styles.gridRowCell} style={getStyleTd("75px", "75px")}>
                                                            {item.cells.find((x) => x["propertyName"] === "idError")?.value}
                                                        </td>
                                                    )}
                                                    {orderedCells.map((cell, cellIndex) => {
                                                        return (
                                                            cell.visibility && (
                                                                <MainViewTd
                                                                    item={cell}
                                                                    row={item}
                                                                    index={cellIndex}
                                                                    getStyleCell={props.getStyleCell}
                                                                    orderedCells={orderedCells}
                                                                    rowHeight={pluginSettings.rowHeight}
                                                                    documentStatusIsProc={isProc}
                                                                    renderCustomCell={props.renderCustomCell}
                                                                />
                                                            )
                                                        );
                                                    })}
                                                </tr>
                                            );
                                        })}
                                </tbody>
                            </table>
                        </div>
                        {sendRequest && (
                            <div className={styles.spin}>
                                {" "}
                                <Spinner xl />
                            </div>
                        )}
                        {props?.separator && <div onMouseDown={onMouseHoldDown} className={classNames(defaultStyles.separator, defaultStyles.separator_horizontal)}></div>}
                        {props.hiddenPagination && (
                            <GridPaginator
                                nearPage={2}
                                pageNumber={props.filter.pageNumber}
                                totalCount={actualTotalCount}
                                numberPerPage={props.filter.numberPerPage}
                                onPageNumberChange={props.onPageNumberChange}
                                onNumberPerPageChange={props.onNumberPerPageChange}
                                hiddenNumberPage={props.hiddenPagination?.["hiddenNumberPage"]}
                                hiddenCountRow={props.hiddenPagination?.["hiddenCountRow"]}
                            />
                        )}
                        {gridHeaderContextMenuVisible && (
                            <ContextMenu
                                id={getContextId("header", props.gridId)}
                                xPos={headerCtxPosX}
                                yPos={headerCtxPosY}
                                items={[
                                    {
                                        name: "Настройки таблицы",
                                        onClick: () => setShowGridHeaderSettings(true),
                                    },
                                    {
                                        name: "Выгрузить таблицу",
                                        onClick: () => handleExport(),
                                    },
                                ]}
                            />
                        )}
                        {gridRowContextMenuVisible && <ContextMenu id={getContextId("row", props.gridId)} xPos={headerCtxPosX - 300} yPos={headerCtxPosY - 140} items={props.contextMenuItems ?? []} />}
                        {showGridHeaderSettings && (
                            <GridUISettings
                                plugin={pluginSettings}
                                defaultPlugin={defaultPlugin}
                                save={(e) => {
                                    if (e.columns) {
                                        setGridColumnsToSave({ columns: e.columns, save: true });
                                    }
                                    setPluginSettings({ ...pluginSettings, rowHeight: e.rowHeight });
                                    setGridHeaderContextMenuVisible(false);
                                    setShowGridHeaderSettings(false);
                                }}
                                cancel={() => {
                                    setGridHeaderContextMenuVisible(false);
                                    setShowGridHeaderSettings(false);
                                }}
                            ></GridUISettings>
                        )}

                        {gridRowContextMenu}
                    </div>
                </>
            )}
        </>
    );
};

interface IMainViewTdProps {
    item: IGridCellWithWidth;
    index: number;
    row: IGridRow;
    getStyleCell?: (processedCell: IGridCell, cells: IGridCell[]) => string | null;
    orderedCells: IGridCellWithWidth[];
    rowHeight?: number;
    documentStatusIsProc?: boolean;
    renderCustomCell?: (cell: IGridCell, row: IGridRow) => React.ReactNode;
}

const MainViewTd: FC<IMainViewTdProps> = ({ item, index, row, getStyleCell, orderedCells, rowHeight, documentStatusIsProc, renderCustomCell }) => {
    const [spanWidth, setSpanWidth] = useState<boolean>(false);
    const tdMainRef = useRef<HTMLTableCellElement>(null);
    const [formatTooltip, setFormatTooltip] = useState<string>("");

    const [copyVisibility, setCopyVisibility] = useState<boolean>(false);

    const CopyLowOpacity = 0.4;
    const CopyHighOpacity = 0.85;
    const [copyOpacity, setCopyOpacity] = useState<number>(CopyLowOpacity);

    const actionForRef = (ref: RefObject<HTMLTableCellElement>) => {
        if (ref && ref.current) {
            const tdElement = ref.current;
            const tdElementCss = getComputedStyle(tdElement);
            const tdWidth = tdElement.offsetWidth - (parseFloat(tdElementCss.paddingLeft) + parseFloat(tdElementCss.paddingRight)) - 5;

            const span = tdElement.querySelector("span");
            const spanWidth = span?.scrollWidth;

            (spanWidth as number) > tdWidth ? setSpanWidth(true) : setSpanWidth(false);
        }
    };

    const customContent = renderCustomCell?.(item, row);
    if (customContent) {
        return (
            <td
                onMouseEnter={() => {
                    actionForRef(tdMainRef);
                    setCopyVisibility(true);
                }}
                onMouseLeave={() => {
                    setCopyVisibility(false);
                }}
                ref={tdMainRef}
                key={index}
                className={classNames(styles.gridRowCell, getStyleCell?.(item, orderedCells))}
                style={{ width: item.width, minWidth: item.width, height: rowHeight, cursor: "default" }}
                data-order-number={item.order}
                data-property-name={item.propertyName}
            >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                    {customContent}
                </div>
            </td>
        );
    }

    return (
        <td
            onMouseEnter={() => {
                actionForRef(tdMainRef);
                setCopyVisibility(true);
            }}
            onMouseLeave={() => {
                setCopyVisibility(false);
            }}
            ref={tdMainRef}
            key={index}
            className={classNames(styles.gridRowCell, getStyleCell?.(item, orderedCells))}
            style={{ width: item.width, minWidth: item.width, height: rowHeight, cursor: "default" }}
            data-order-number={item.order}
            data-property-name={item.propertyName}
        >
            <Tooltip
                className={styles.gridRowCellText}
                title={spanWidth && formatTooltip}
                placement="top"
                autoAdjustOverflow={false}
                overlayStyle={{ maxWidth: 300 }}
                getPopupContainer={() => document.body}
            >
                <span style={{ width: "100%" }}>
                    <FormattedValueView newValue={item} setFormatTooltip={setFormatTooltip} documentStatusIsProc={documentStatusIsProc} />
                </span>
            </Tooltip>
            <span
                style={{
                    opacity: copyVisibility ? copyOpacity : 0,
                    transition: "opacity 0.3s ease-in",
                    marginRight: -10,
                    paddingLeft: 1,
                    width: 16,
                    height: 16,
                    cursor: "pointer",
                    backgroundColor: "white",
                    borderRadius: 3,
                }}
                onClick={async () => {
                    await copyToClipboard(getFormattedCellValue(item, documentStatusIsProc));
                }}
            >
                <ActionIcons.CopyMiniIcon onMouseEnter={() => setCopyOpacity(CopyHighOpacity)} onMouseLeave={() => setCopyOpacity(CopyLowOpacity)} />
            </span>
        </td>
    );
};
